var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36.6667,
    height: 36.6667,
    viewBox: "0 0 36.6667 36.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 36.6667C8.16667 36.6667 0 28.5 0 18.3333C0 17.3333 0.666667 16.6667 1.66667 16.6667C2.66667 16.6667 3.33333 17.3333 3.33333 18.3333C3.33333 26.6667 10 33.3333 18.3333 33.3333C26.6667 33.3333 33.3333 26.6667 33.3333 18.3333C33.3333 10 26.6667 3.33333 18.3333 3.33333C17.3333 3.33333 16.6667 2.66667 16.6667 1.66667C16.6667 0.666667 17.3333 0 18.3333 0C28.5 0 36.6667 8.16667 36.6667 18.3333C36.6667 28.5 28.5 36.6667 18.3333 36.6667Z",
    fill: "url(#paint0_linear_0_34)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_34",
    x1: 20.0725,
    y1: 2.68116,
    x2: 0.0724641,
    y2: 23.5507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15967C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456731,
    stopColor: "#3FA360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72B33E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofSpinner);
export default __webpack_public_path__ + "static/media/proof-spinner.77b0f357f454b8c73f27bfdf978ee71d.svg";
export { ForwardRef as ReactComponent };